import styled from 'styled-components'

export const BreadBox = styled.nav`
  ul {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 8px;

    li {
      font-size: var(--font-size-md);
      color: var(--theme-primary);

      svg {
        color: var(--black);
        margin-left: 8px;
      }
    }

    @media (max-width: 575px) {
      li {
        font-weight: bold;
        font-size: var(--font-size-ssm);
      }

      svg {
        display: none;
      }
    }
  }
`
